import { AppId } from '@wix/cashier-common/dist/src/enums/AppId';
import { createGlobalConfig, PanoramaPlatform } from '@wix/panorama-client-web';

export const globalConfig = createGlobalConfig();

export const baseParams: Omit<BaseParams, 'componentId'> = {
  platform: PanoramaPlatform.Standalone,
  fullArtifactId: 'com.wixpress.payment.cashier-payments-app',
  appDefId: AppId.Cashier,
};

export const ComponentId = {
  CashierPaymentsApp: 'cashier-payments-app',
  NoPaymentsPopup: 'no-payments-popup',
  NoPaymentMethods: 'no-payment-methods',
  PremiumPopup: 'premium-popup',
  PaymentResultPage: 'payment-result-page',
  ProcessingPage: 'processing-page',
} as const;

export type BaseParams = {
  platform: PanoramaPlatform;
  fullArtifactId: string;
  componentId: string;
  appDefId: AppId;
  uuid?: string;
  msid?: string;
};

export const sentryDsn = 'https://23860719b0fe4d208060601abeedb71f@sentry.wixpress.com/133';
